import React ,{useEffect} from 'react';
import AOS from 'aos';
import Header from '../Components/Shared/Header/Header';
import Blogs1 from '../Components/Pages/Blog/Blogs1';
import Cards from '../Components/Pages/Blog/Cards1';
import Cards2 from '../Components/Pages/Blog/Cards2';
import Start from '../Components/Shared/Start/Start';
import Footer from '../Components/Shared/Footer/Footer';
import VideoPart from '../Components/Pages/Blog/VideoPart';
function Blogs(){
    useEffect(() => {
        AOS.init({
          duration: 800,
          disable: 'mobile',
          once: true,
        });
      }, []);
    return(
        <>
        <Header styles="scrolled" />
        <Blogs1 />
        <Cards />
        <VideoPart />
        <Cards2 />
        <Start />
        <Footer />
        </>
    )
};
export default Blogs ;